import { z } from "zod";

// ============================================================================
// BASE AUDIT LOG SCHEMA (matches backend DbAuditLogOutput)
// ============================================================================

// To sync with DbAuditLogOutput in backend/schemas/audit-log.ts
const BaseAuditLogSchema = z.object({
  // Primary fields
  id: z.string(),

  // Relations
  workspaceId: z.string(),
  userId: z.string(),

  // Timestamps
  createdAt: z.string(),

  // Data fields
  action: z.string(), // 'create' | 'update' | 'delete' | 'archive' | 'restore'
  entityType: z.string(), // 'agent' | 'workflow' | 'phase' | 'patient' | 'follow_up' | etc.
  entityId: z.string().nullable(),
  changes: z.record(z.string(), z.unknown()).nullable().optional(),
  ipAddress: z.string().nullable().optional(),
  userAgent: z.string().nullable().optional(),
  metadata: z.record(z.string(), z.unknown()).nullable().optional(),
});

export const AuditLogSchema = BaseAuditLogSchema;

export const AuditLogListItemSchema = BaseAuditLogSchema.extend({
  userName: z.string().nullable().optional(),
  userEmail: z.string().nullable().optional(),
  userFirstName: z.string().nullable().optional(),
  userLastName: z.string().nullable().optional(),
  entityName: z.string().nullable().optional(),
});

export const AuditLogListSchema = z.array(AuditLogListItemSchema);

// ============================================================================
// TYPE EXPORTS
// ============================================================================

export type AuditLog = z.infer<typeof AuditLogSchema>;
export type AuditLogListItem = z.infer<typeof AuditLogListItemSchema>;
